import type { MailboxInfo } from 'owa-client-types';

export interface McpWidgetComposeParameters {
    readonly draftId: string;
    readonly routeKey?: string;
    readonly mcpHandoffMode?: string;
}

export type McpWidgetComposeHandler = (
    parameters: McpWidgetComposeParameters,
    targetWindow: Window,
    mailboxInfo: MailboxInfo
) => void;

let registeredHandler: McpWidgetComposeHandler | undefined;

export function registerMcpWidgetComposeHandler(handler: McpWidgetComposeHandler): () => void {
    registeredHandler = handler;
    return () => {
        if (registeredHandler === handler) {
            registeredHandler = undefined;
        }
    };
}

export function dispatchMcpWidgetCompose(
    parameters: McpWidgetComposeParameters,
    targetWindow: Window,
    mailboxInfo: MailboxInfo
): void {
    registeredHandler?.(parameters, targetWindow, mailboxInfo);
}
